export default __webpack_public_path__ + "static/media/Existing_Base.e34700dd.jpg";